import React from 'react';
import {
  BasedOnYourRecentlyViewed,
  Categories,
  HomepageSearchRecommendations,
  JustListed,
  MostWatchedRow,
  ReverbAppCallout,
} from './logged_out/content_components';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';

export function DefaultLoggedOutHomepage() {
  return (
    <>
      <div className="mb-gap-row">
        <CmsEmbed slug="logged-out-homepage-top-desktop" ssrMode="full" />
      </div>
      <BasedOnYourRecentlyViewed />
      <MostWatchedRow />
      <HomepageSearchRecommendations />
      <CmsEmbed slug="logged-out-homepage-mid" ssrMode="off" />
      <JustListed />
      <Categories />
      <CmsEmbed slug="logged-out-homepage-low" ssrMode="off" />
      <ReverbAppCallout />
    </>
  );
}

function LoggedOutHomepage() {
  return <DefaultLoggedOutHomepage />;

}

export default LoggedOutHomepage;
